import { Directive, TemplateRef } from '@angular/core';
import { TabDirective } from './tab.directive';
/** Should be used to mark <template> element as a template for tab heading */
export var TabHeadingDirective = (function () {
    function TabHeadingDirective(templateRef, tab) {
        tab.headingRef = templateRef;
    }
    TabHeadingDirective.decorators = [
        { type: Directive, args: [{ selector: '[tabHeading]' },] },
    ];
    /** @nocollapse */
    TabHeadingDirective.ctorParameters = function () { return [
        { type: TemplateRef, },
        { type: TabDirective, },
    ]; };
    return TabHeadingDirective;
}());
//# sourceMappingURL=tab-heading.directive.js.map


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/ngx-bootstrap/tabs/tab-heading.directive.js
// module id = ../../../../ngx-bootstrap/tabs/tab-heading.directive.js
// module chunks = 5